import { z } from "zod";
import { recordId } from "./contracts";

export const PAYER_PROFILE_CONSENT_VERSION = "payer-profile-off-session-v1";

export const payerProfileQuery = z.object({ actingOrganization: recordId.toLowerCase() });
export type PayerProfileQuery = z.infer<typeof payerProfileQuery>;

export const payerProfileRequest = z.object({ actingOrganization: recordId.toLowerCase() }).strict();
export type PayerProfileRequest = z.infer<typeof payerProfileRequest>;

export const payerProfileFinalizeRequest = payerProfileRequest
  .extend({
    setupIntent: z.string().trim().min(1).max(255),
    consentAccepted: z.literal(true, { message: "Accept the authorization before saving this payer profile." }),
    consentVersion: z.literal(PAYER_PROFILE_CONSENT_VERSION, { message: "Reload the page to accept the current authorization." }),
  })
  .strict();
export type PayerProfileFinalizeRequest = z.infer<typeof payerProfileFinalizeRequest>;

export const payerProfileStatus = z.enum(["pendingSetup", "active", "requiresAction", "disabled", "setupFailed"]);
export type PayerProfileStatus = z.infer<typeof payerProfileStatus>;

export const savedPaymentMethodType = z.enum(["card", "us_bank_account"]);
export type SavedPaymentMethodType = z.infer<typeof savedPaymentMethodType>;

export const payerProfile = z.object({
  payer: recordId,
  status: payerProfileStatus,
  paymentMethodType: savedPaymentMethodType.nullable(),
  brandOrBankName: z.string().nullable(),
  last4: z.string().nullable(),
  expMonth: z.number().int().nullable(),
  expYear: z.number().int().nullable(),
});
export type PayerProfile = z.infer<typeof payerProfile>;

export const payerProfileState = z.object({ profile: payerProfile.nullable() });
export type PayerProfileState = z.infer<typeof payerProfileState>;

export const payerProfileSetup = z.object({ clientSecret: z.string().nullable(), setupIntent: z.string(), profile: payerProfile });
export type PayerProfileSetup = z.infer<typeof payerProfileSetup>;
